<template>
	<div>
		<div class="filter-inline-panel cle">
			<el-form :inline="true" size="mini" :model="filterForm" class="filter-panel">
				<el-form-item>
				</el-form-item>
			</el-form>
			<div class="list-opinion fr">
		        <el-button type="primary" size="mini" @click="$router.back(-1)">{{$t('index.return')}}</el-button>
			</div>
		</div>
		<el-table :data="list" size="mini" border>
			<el-table-column prop="order_id" align="center" :label="$t('order.no')" data-name="id"></el-table-column>
			<el-table-column :prop="lang=='cn'?'theme_cn':'theme'" align="center" :label="$t('course_index.theme')" data-name="主题">
				<template slot-scope="scope"><a target="_blank" class="clo3" :href="API_URL+'#/course_activity_info?id='+scope.row.course_id">{{lang=='cn'?scope.row.theme_cn:scope.row.theme}}</a></template>
			</el-table-column>
			<el-table-column prop="parent_name" align="center" :label="$t('student_list.parent_name')" data-name="家长姓名"></el-table-column>
			<el-table-column prop="email" align="center" :label="$t('student_list.email')" data-name="email"></el-table-column>
			<el-table-column prop="tel" align="center" :label="$t('student_list.tel')" data-name="电话"></el-table-column>
			<el-table-column prop="child_name" align="center" :label="$t('order.child_name')" data-name="学生姓名"></el-table-column>
			<el-table-column prop="age" align="center" :label="$t('order.child_age')" data-name="学生年龄">
				<template slot-scope="scope">{{scope.row.age}}y</template>
			</el-table-column>
			<el-table-column prop="grade" align="center" :label="$t('order.child_grade')" data-name="学生年级">
				<template slot-scope="scope">{{grade_f(scope.row.grade)}}</template>
			</el-table-column>
			<el-table-column :prop="'field_data.'+item.code" align="center" :label="lang=='cn'?item.name_cn:item.name" v-for="(item,index) in activity_field" :key="index">
				<template slot-scope="scope">
					<p class="clo3 tag-read" @click="copy" :data-clipboard-text="scope.row.field_data[item.code]">{{scope.row.field_data[item.code]}}</p>
				</template>
			</el-table-column>
		</el-table>
		<div class="page-pagination">
			<el-pagination align="right" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pagerCount="5"></el-pagination>
		</div>
	</div>
</template>
<script>
import Clipboard from 'clipboard'; 
export default {
	data() {
		return {
			API_URL:process.env.API_URL,
			this_:this,
			id:'',
			filterForm:{},
			list: [],
			pages: {
				page: 1,
				count: 0,
				perpage: 20,
			},
			GRADE:[],
			activity_field:[],

			xuanzyoujian_is:false,
		}
	},
	// 初始事件
	mounted: function () {
		this.id=this.$route.query.id;
		this.config();
		this.init();
	},
	// 事件
	methods: {
		config() {
			var this_ = this;
			var url = "getDictionaryValue";
			var datas = {
				code: 'GRADE_LIST',
			}
			this_.$post(url, datas).then((res) => {
				this_.GRADE = res.GRADE_LIST;
			})
		},
		// 初始化
		init: function () {
			var this_ = this;
			var url = "activityStudentList"
			var datas = {
				id:this_.id,
				page: this_.pages.page,
				num: this_.pages.perpage,
			}
			this_.$post(url, datas).then((res) => {
				this_.activity_field = res.activity_field;
				this_.list = res.list;
				this_.pages.count = res.num;
			})
		},
		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		},
		works_f(href){
			if (href.indexOf('http')!=-1) {
				var a = document.createElement('a');
				a.setAttribute('href', href);
				a.setAttribute('target', '_blank');
				a.setAttribute('id', 'js_a');
				if(document.getElementById('js_a')) {
					document.body.removeChild(document.getElementById('js_a'));
				}
				document.body.appendChild(a);
				a.click();
			}
		},
		grade_f(v){
			var this_=this;
			var list=this.GRADE;
			var name='';
			list.forEach(function(e,i) {
				if (e.code==v) {
					name=this_.lang=='cn'?e.name_cn:e.name;
				}
			});
			return name;
		},
		// 复制
		copy(){
			var this_ = this;
			var clipboard = new Clipboard('.tag-read');
			clipboard.on('success', e => {
				this_.$message.success(this_.$t('index.copy_success'));
				clipboard.destroy()
			})
			clipboard.on('error', e => {
				this_.$message.success(this_.$t('index.copy_error'));
				clipboard.destroy()
			})
		},
	},
	// 过滤器
	filters: {
	}
}
</script>
<style scoped>
.matop{
	margin-top: 10px;
}
.clo3{
	color: #ff0000;
	cursor: pointer;
}
.filter-inline-panel {
	margin-bottom: 18px;
}
.filter-panel {
	display: inline-block;
	width:calc( 100% - 215px );
	vertical-align: top;
}
.dialog-header{
	text-align: right;
	padding-bottom: 20px;
}
.line{
	text-align: center;
}
.el-date-editor.w100{
	width: 100%;
}
</style>
<style type="text/css">
textarea{
	font-family: inherit;
}
</style>



// WEBPACK FOOTER //
// src/views/teacher/activity_list.vue